import DiscountPrice from "./DiscountPrice";
import DayPrice from "./DayPrice";
import React from "react";
import WeekEndPrice from "./WeekEndPrice";
import t from "../../../../helpers/t";

const PricesTable = (props) => {
    const { hiding, weekEndPrice, weekdayPrice, timeBasedPricetype, dayPrice, discountPrice, multipleUnitPrice, priceLocal, onChangeForm, weekdayBegin, timeBeginHours, hours, timeBeginMinutes, minutes, weekdayEnd, timeEndHours, timeEndMinutes, weekDailyPrice} = props;
    return (
        <>
            <table className="pricesFormTable" style={{display:'block'}}>
                <thead>
                <tr>
                    {!weekEndPrice && <> <th className={hiding.a}>
                        {t('price_standard', null, ' capital')}
                        <i className="fi fi-info" title={t('price_default_info',null,'capital')}></i>
                    </th> </>}
                    {weekdayPrice && <>
                        <th>Mo</th>
                        <th>Tu</th>
                        <th>We</th>
                        <th>Th</th>
                        <th>Fr</th>
                        <th>Sa</th>
                        <th>Su</th>
                    </>}
                    {timeBasedPricetype && <>
                        <th className={hiding.a}>
                            {t('first_unit_cost_free', null, ' capital')}
                            <i className="fi fi-info" title={t('first_unit_cost_free_info',null,'capital')}></i>
                        </th>
                    </>}
                    {multipleUnitPrice &&
                        <>
                            <th style={{textAlign:'left'}}>
                                {t('count_units')}
                            </th>
                        </>
                    }
                    {discountPrice && <>
                        <th style={{textAlign:"left"}}>
                            {t('valid_from_')}
                            <i style ={{paddingLeft:"5px"}} className="fi fi-info" title={t('discount_price_info',null,'capital')}></i>
                        </th>
                    </>
                    }
                    { dayPrice &&
                        <>
                            <th style={{textAlign:"left",width:"27%"}}>
                                {t('Mengenrabatt')}
                                <i style={{paddingLeft:"5px"}} className="fi fi-info" title={t('mengenrabatt_info',null,'capital')}></i>
                            </th>
                        </>
                    }
                </tr>
                </thead>
                <tbody>
            <tr>
                {!weekEndPrice && <>  <td className={hiding.b}>
                    <input className="pricetariff-price input-group-field is-standard-amount" name="amount" type="text" value={priceLocal.amount} onChange={(e) => onChangeForm(e)}/>
                </td></>}
                {weekdayPrice && <>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_1"
                               value={priceLocal.amount_weekday_1} onChange={(e) => onChangeForm(e)}/>
                    </td>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_2"
                               value={priceLocal.amount_weekday_2} onChange={(e) => onChangeForm(e)}/>
                    </td>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_3"
                               value={priceLocal.amount_weekday_3} onChange={(e) => onChangeForm(e)}/>
                    </td>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_4"
                               value={priceLocal.amount_weekday_4} onChange={(e) => onChangeForm(e)}/>
                    </td>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_5"
                               value={priceLocal.amount_weekday_5} onChange={(e) => onChangeForm(e)}/>
                    </td>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_6"
                               value={priceLocal.amount_weekday_6} onChange={(e) => onChangeForm(e)}/>
                    </td>
                    <td className="weekday_price">
                        <input className="pricetariff-price input-group-field" type="text" name="amount_weekday_7"
                               value={priceLocal.amount_weekday_7} onChange={(e) => onChangeForm(e)}/>
                    </td>
                </>
                }
                {timeBasedPricetype &&
                    <>
                        <td style={{textAlign:"center"}} className="weekday_price standard-price-column">
                            <input type="checkbox" name="first_unit_cost_free"
                                   checked={priceLocal.first_unit_cost_free}  onChange={(e) => onChangeForm(e)}/>
                        </td>
                    </>
                }
                {multipleUnitPrice &&
                    <>
                        <td className="weekday_price standard-price-column">
                            <input className="pricetariff-price input-group-field" type="text" name="units"
                                   value={priceLocal.units} onChange={(e) => onChangeForm(e)}/>
                        </td>
                    </>
                }
                {discountPrice &&
                    <DiscountPrice
                        priceLocal={priceLocal}
                        onChangeForm={onChangeForm}
                    />
                }
                {dayPrice &&
                    <DayPrice
                        priceLocal={priceLocal}
                        onChangeForm={onChangeForm}
                    />
                }
                {weekEndPrice &&
                    <WeekEndPrice
                        priceLocal={priceLocal}
                        onChangeForm={onChangeForm}
                        weekdayBegin={weekdayBegin}
                        timeBeginHours={timeBeginHours}
                        hours={hours}
                        timeBeginMinutes={timeBeginMinutes}
                        minutes={minutes}
                        weekdayEnd={weekdayEnd}
                        timeEndHours={timeEndHours}
                        timeEndMinutes={timeEndMinutes}
                    />

                }
            </tr>
                </tbody>
            </table>
        </>
    )
}
export default PricesTable;